import { render, staticRenderFns } from "./cancelRealName.vue?vue&type=template&id=a4afa72a&"
import script from "./cancelRealName.vue?vue&type=script&lang=js&"
export * from "./cancelRealName.vue?vue&type=script&lang=js&"
import style0 from "./cancelRealName.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports